// material-ui
import { styled } from '@mui/material/styles';
import PlanimatorIcon from 'components/Logo/PlanimatorLogo';
// loader style
const LoaderWrapper = styled('div')(({ theme }) => ({
  // position: 'fixed',
  // top: 0,
  // left: 0,
  // zIndex: 2001,
  // width: '100%',
  // '& > * + *': {
  //   marginTop: theme.spacing(2)
  // }
}));

// ==============================|| Loader ||============================== //

const LoaderIcon = ({ size, color }) => (
  <LoaderWrapper>
    {/* <VaseelahIcon faded loader /> */}
    <PlanimatorIcon faded loader />
  </LoaderWrapper>
);

export default LoaderIcon;
